export default "__VITE_ASSET__6TwrkOxR__"